import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template imports
import Typography from  '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CheckmarkBoldIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CheckmarkBold';

export const CheckmarkBoldIconStyled = styled(CheckmarkBoldIcon)`
  display: block;
  margin: 0 auto;
`;

export const DivStyledTableContainer = styled.div`
  ${({ theme }) => {
    const largeUp = theme.largeUp();
    const thisMaxWidth = rem(theme.breakpoints.values.large1200);
    return css`
      max-width: unset;
      ${largeUp && `max-width: ${thisMaxWidth};`};
    `;
  }
}`;

export const TypographyStyledHeading = styled(Typography)`
  padding-bottom: ${rem(40)};
  padding-left: ${rem(8)};
  padding-right: ${rem(8)};
`;

export const TableStyled = styled.table`
  ${({ theme }) => css`
    background-color: ${theme.colors.neutral.grayLight2};
    width: 100%;
    border-collapse: collapse;
    caption {
      display: none;
    }
  `}
`;

export const TableRowStyledHeading = styled.tr`
  ${({ theme }) => css`
    background-color: ${theme.colors.blue.blue};
  `}
`;

export const TableHeadingStyledCell = styled.th`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      color: ${theme.colors.neutral.white};
      padding: ${mediumUp ? `${rem(16)} ${rem(32)}` : `${rem(16)} ${rem(8)}`};
      font-size: ${mediumUp ? rem(21) : rem(16)};
      line-height: ${mediumUp ? rem(28) : rem(24)};
      font-weight: 400;
      &:not(.column-benefits) {
        ${mediumUp && `border-left: ${rem(2)} solid ${theme.colors.neutral.white};`};
      }
      @media print {
        border-bottom: ${theme.colors.neutral.black} ${rem(3)} solid !important;
      }
      &.column-benefits {
        color: transparent !important;
      }
    `;
  }
}`;

export const TableDataStyledBody = styled.td`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      background-color: ${theme.colors.neutral.white};
      min-width: ${mediumUp ? rem(60) : rem(30)};
      padding: ${mediumUp ? `${rem(16)} ${rem(32)}` : `${rem(16)} ${rem(8)}`};
      font-size: ${rem(20)};
      line-height: ${rem(30)};
      font-weight: 400;
      text-align: left;
      border-left: ${rem(2)} solid ${theme.colors.neutral.grayLight2};
      @media print {
        .nmx-icon {
          .icon-fill {
            fill: ${theme.colors.neutral.black} !important;
          }
        }
      }
    `;
  }
}`;

export const TableHeadingStyledBody = styled.th`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const padding = mediumUp ? rem(32) : rem(16);
    return css`
      background-color: ${theme.colors.neutral.grayLight3};
      min-width: ${mediumUp ? rem(130) : rem(30)};
      padding-left: ${padding};
      padding-right: ${mediumUp ? rem(32) : rem(8)};
      padding-top: ${padding};
      padding-bottom: ${padding};
      text-align: left;
      font-size: ${mediumUp ? rem(18) : rem(15)};
      line-height: ${mediumUp ? rem(28) : rem(22)};
      font-weight: 400;
    `;
  }
}
`;

export const TableRowStyled = styled.tr`
  ${({ theme }) => css`
    border-bottom: ${rem(2)} solid ${theme.colors.neutral.grayLight2};
  `}
`;

